import React from 'react';


const NoContentFoundPage = () => {
    return (
        <div className='container text-center py-5'>
            <h1 style={{fontSize: '500%'}}>404 NOT FOUND</h1>
        </div>
    );
};

export default NoContentFoundPage;